import * as ko from "knockout";
import * as mapping from "knockout.mapping";
import * as $ from "jquery";
import { Newspaper } from "../../Models/NewspaperRequestModels/newspaper";
import { LiveSubscriptionReportParams } from "../../Models/NewspaperRequestModels/liveSubscriptionReportParams";
import { Period } from "../../Models/NewspaperRequestModels/period";
import { LiveSubscriptionDataModel } from "../../Models/NewspaperRequestModels/liveSubscriptionDataModel";
import { KnockoutHelper } from "../../knockoutHelper";

class LiveSubscriptionReportFormViewModel {
    dropdownsOptions: any;
    reportParams: any;
    isSearching: any;
    

    constructor(params: any) {
        this.dropdownsOptions = params.dropdownsOptions;
        this.reportParams = new LiveSubscriptionReportParams();
        this.isSearching = ko.observable<boolean>(false);
    }

    search(parents: any): void {
        this.reportParams.periods.removeAll();

        this.isSearching(true);

        for (let periodString of this.reportParams.periodIds()) {
            let newPeriod = new Period();
            let splitedPeriod = periodString.split("-");

            newPeriod.year(splitedPeriod[0]);
            newPeriod.quarter(splitedPeriod[1]);

            this.reportParams.periods.push(newPeriod);
        }

        let mappingOption = {
            'ignore': ["id", "displayName", "periodIds"]
        }

        $.ajax({
            method: "POST",
            url: "LiveSubscription/Details",
            data: mapping.toJS(this.reportParams, mappingOption)
        })
            .done((response) => {
                $("#data-table").DataTable().destroy();

                let dataTablesOptions = {
                    buttons: [
                        parents[0].dataTablesExcelExportButtonOptions
                    ],
                    language: parents[0].dataTablesLanguageOptions,
                    data: response.data,
                    columns: [
                        { data: 'requestId' },
                        { data: 'addressName' },
                        { data: 'recipientName' },
                        { data: 'newspaperName' },
                        { data: 'originalQuantity' },
                        { data: 'changedQuantityWithPrefix' },
                        { data: 'resultQuantity' },
                        { data: 'action' },
                        { data: 'statusName' },
                        { data: 'period' },
                        { data: 'lastSubscriptionDateString' },
                        { data: 'roundedPriceString' },
                        { data: 'subscriptionStartDateString' }
                    ],
                    columnDefs: [{ "defaultContent": "", "targets": "_all" }]
                };
                KnockoutHelper.initDataTablesWithExcelButton("data-table", dataTablesOptions);
            })
            .fail((e) => {
                console.log("HIBA A LEKÉRDEZÉSKOR!!");
                console.log(e);
            })
            .always(() => {
                this.isSearching(false);
            });
    }
}

export class LiveSubscriptionReportFormComponent {
    constructor() {
        return {
            viewModel: LiveSubscriptionReportFormViewModel,
            template: require("text-loader!./liveSubscriptionReportFormView.html")
        }
    }
}